<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
      v-col.py-0.text-right
        v-btn(color="white", @click="save()", :disabled="disabledSave", v-if="ShowEntityEdit(entityName)") {{ $t('Common.save') }}
    p.v-messages.theme--light.error--text(v-if="!!customErrors")
      span(v-for="error in customErrors") {{ error }}
    v-row(v-show="!loading")
      v-col.py-0
        v-card.elevation-24.mb-5
          app-full-entity(v-if="!loading", :entity="entity")
</template>

<script>
import { assign, camelCase } from 'lodash'
import axios from 'axios'
import EntitySpecificScenarios from '@/mixins/entitySpecificScenarios'
import EntityMixin from '@/mixins'
import EntityLoadsMixin from "@/mixins/entity-loads.mixin";

export default {
  /*
  *
  */
  mixins: [EntityMixin, EntitySpecificScenarios, EntityLoadsMixin],

  /*
  *
  */
  name: 'entity-add',

  /*
  *
  */
  data: () => ({
    customErrors: [],
    disabledSave: false,
    loading: true,
    errors: {
      //
    }
  }),

  /*
  *
  */
  computed: {

    /*
    *
    */
    entityName () {
      return this.$route.params.entity
    },

    /*
    *
    */
    entity () {
      return this.$searchEntity(this.entityName, 'name')
    },

    /*
    *
    */
    uid () {
      return this.$route.params.item
    },
    loadExtraData() {
      return this.$isExtraDateable(this.entity) ? '?load[]=ExtraData' : ''
    }
  },

  /*
  *
  */
  methods: {
    /*
    Resolves a route by a given entity name, if the resolved route path is empty, the route does not exists
    */
    indexRouteExists(entityName) {
      const resolved = this.$router.resolve({
        name: `${camelCase(entityName)}.index`
      });
      if(resolved && resolved.route && resolved.route.fullPath !== "/") return true;
      return false;
    },
    /*
    *
    */
    update (instance, entity) {
      this.instance = assign({}, this.instance, entity ? { [entity]: instance } : instance)
    },

    /*
    *
    */
    async save () {
      try {
        this.disabledSave = true;
        if (this.instance.businessScope == null || this.instance.businessScopeId === null) this.instance.businessScopeId = this.$getBusinessScopeId()
        if (!await this.validForSpecificScenarios(this.entity, this.instance)) { this.disabledSave = false; return; }
        await this.beforeSaveForSpecificScenarios(this.entity, this.instance);
        var response = (await axios.post('entity/graph', this.instance))
        await this.afterSaveForSpecificScenarios(this.entity, this.instance, response);
        if (ENV.AFFECT_SCHEMA[response.data._Entity]){
          this.$updateSchema(this.$store, axios, 20000)
        }
        this.instance = response.data
        this.$router.push({
          name: this.indexRouteExists(this.entity.name) ? `${camelCase(this.entity.name)}.index` : 'entities.index',
          params: { entity: this.entity.name }
        })
      } catch (error) {
        console.log(`[Add][save] error: `, this.$cleanString(error))
        this.errors = error.response.data.errors
        this.$store.commit('SET_ERRORS', this.errors)
        this.$store.commit('SET_ERROR_MODAL', true)
        this.errorsForSpecificScenarios(this.entity, this.errors);
      } finally {
        this.disabledSave = false;
      }
    },

    /*
    *
    */
    async load () {
      if (this.uid) {
        try {
          this.instance = (await axios.get(`${this.entity.name}/${this.uid}${this.loadExtraData}`, {
            _Entity: this.entity.name,
            uid: this.uid,
            params: {
              Load: [...this.$entityLoads(this.entity)],
            }
          })).data
          this.instance.entityState = 3
          this.$store.commit('SET_INSTANCE', this.instance)
        } catch (error) {
          console.error(error)
        }
      }
      this.loading = false
    }
  },

  /*
  *
  */
  created () {
    this.$store.commit('SET_INSTANCE', null)
  },

  /*
  *
  */
  async mounted () {
    await this.load()
  }
}
</script>
